import EventPublisher from "../utils/EventPublisher";
import UIInteractionEvents from "../constants/events/UIInteractionEvents";
import ActionResultEvents from "../constants/events/ActionResultEvents";
import SessionAPIClient from "../client/SessionAPIClient";

class SessionActions {

    constructor() {
        this.sessionApiClient = new SessionAPIClient();
        EventPublisher.subscribe(UIInteractionEvents.FACEBOOK_LOGIN_BUTTON_CLICKED, this.handleFBLogin);
        EventPublisher.subscribe(UIInteractionEvents.LOGOUT_BUTTON_CLICKED, this.handleFBLogout);
        //TODO do we need some kind of listener for changes in the FB auth?
        //  FB.Event.subscribe('auth.authResponseChange', function(response) { // or auth.statusChange -- https://developers.facebook.com/docs/reference/javascript/FB.getLoginStatus
        //      // do something with response
        //  });
    }

    handleFBLogin = (topic, data) => {
        window.FB.login(
            (response) => {
                if (response.authResponse) {
                    //TODO - what should we do if FB login succeeds but session build fails - right now we say FB Login failed but that might have odd side effects?
                    this.sessionApiClient.createSession(response.authResponse.userID, response.authResponse.accessToken);
                } else {
                    EventPublisher.publish(ActionResultEvents.FB_LOGIN_FAILED, {});
                }
            }
        );
    };

    handleFBLogout = (topic, data) => {
        this.sessionApiClient.logout();
        window.FB.logout((response) => {}); //TODO - we could check the login status and then logout
    };


}

export default new SessionActions();
